export interface TourOnboardingLifecycle {
    /**
     * Returns true only for the first eligible tour entry in this viewer.
     * Editor viewers never consume the opportunity.
     */
    tryShow(isEditorMode: boolean): boolean;
    dismiss(): void;
    isDismissed(): boolean;
}

/**
 * True once the user has interacted with any scene canvas this page session.
 * MODULE scope on purpose: it survives in-place portal navigation (the viewer
 * is recreated in the same page) and resets on a real refresh — same lifetime
 * as viewerUI's visited-scenes set. A viewer created after interaction (a
 * portal destination) skips the controls onboarding: the user has already
 * shown they know how to drive the scene.
 */
let sessionHasSceneInteraction = false;

export function markSceneInteractionForOnboarding(): void {
    sessionHasSceneInteraction = true;
}

/** Test-only: restore the fresh-page-load state. */
export function resetOnboardingSessionStateForTests(): void {
    sessionHasSceneInteraction = false;
}

/**
 * Keeps onboarding state scoped to one viewer instance. A fresh viewer gets a
 * fresh lifecycle, so reloads and portal destinations can introduce controls —
 * unless the user already interacted with a scene this session (see above).
 */
export function createTourOnboardingLifecycle(): TourOnboardingLifecycle {
    let shown = false;
    let dismissed = false;

    return {
        tryShow(isEditorMode: boolean): boolean {
            if (isEditorMode || shown || dismissed || sessionHasSceneInteraction) return false;
            shown = true;
            return true;
        },
        dismiss(): void { dismissed = true; },
        isDismissed(): boolean { return dismissed; },
    };
}
